import { InsurersEnum } from 'app/shared/enums';

export const onlineTerminationInsurers: Partial<
  Record<InsurersEnum, string>
> = {
  [InsurersEnum.Allianz]:
    'https://kontakt.allianz.pl/form-standalone/kontakt-z-allianz/',
  [InsurersEnum.Beesafe]: 'https://beesafe.pl/portalklienta/wypowiedzenie',
  [InsurersEnum.Benefia]:
    'https://zgloszenie.benefia.pl/obsluga-polisy/wypowiedzenie-umowy-komunikacyjnej-OC/dane-polisy',
  [InsurersEnum.Compensa]:
    'https://zgloszenie.compensa.pl/obsluga-polisy/wypowiedzenie-umowy-komunikacyjnej-OC/dane-polisy',
  [InsurersEnum.Hestia]: 'https://hestia.service-now.com/ergo#scrollAnchor',
  [InsurersEnum.InterRisk]: 'https://interrisk.pl/formularze-online/',
  [InsurersEnum.Link4]:
    'https://www.link4.pl/rezygnacja-z-ubezpieczenia-w-link4',
  [InsurersEnum.Mtu24]: 'https://hestia.service-now.com/ergo#scrollAnchor',
  [InsurersEnum.Pevno]: 'https://form.uniqa.pl/ui/moto/resignation',
  [InsurersEnum.Uniqa]: 'https://form.uniqa.pl/ui/moto/resignation',
  [InsurersEnum.Wiener]:
    'https://obsluga.wiener.pl/wypowiedzenie-umowy/policyInfo',
  [InsurersEnum.YouCanDrive]:
    'https://hestia.service-now.com/ergo#scrollAnchor',
};

export const getOnlineTerminationUrl = (insurer?: string) =>
  insurer ? onlineTerminationInsurers[insurer as InsurersEnum] : undefined;
